import { callApiBase } from './base';

const featuresApi = {
  // FEATURE TOGGLES FOR THE LOGGED CORPORATE
  getFeatures: ({ token }) =>
    callApiBase({
      title: 'Features',
      endpoint: '/v1/features',
      method: 'GET',
      token,
    }),
};

export default featuresApi;
export { featuresApi };
